import React, { useState, useEffect } from 'react'
import _ from 'lodash';
import swal from 'sweetalert';
import DataTable from 'react-data-table-component';
import Grid from '@material-ui/core/Grid';

function CaseListInTableView(props) {
  return (
    <div>
        <Grid className={"datatable-block"} container spacing={3}>
            <DataTable
            //title="Line List"
            striped="true"
            responsive="true"
            pagination
            fixedHeader="true"
            columns={props.columns}
            //data={casesData}
            data={props.data.filter((item) => {
                return item;
            })}
            noDataComponent={
              <div style={{ textAlign: 'center', padding: '20px' }}>
                There are no records to display
              </div>
            }
            />
        </Grid>
    </div>
  )
}

export default CaseListInTableView
